import { assertIsDefined } from '~/types/models'
import type { TProduct } from '~/types/product/models'

export function ProductTypeAndLevelDescr(product: TProduct): string | null {
  const fn =
    '[cynqueModules/ProductTypeAndLevelDescr.ts] ProductTypeAndLevelDescr |'
  if (!product) {
    console.debug(`${fn} returning null`)
    return null
  }
  assertIsDefined(product.type?.label)
  assertIsDefined(product.level?.label)
  const typeAndLevelDescr = product.type.label + '\n' + product.level.label
  console.debug(`${fn} returning '${typeAndLevelDescr}'`)
  return typeAndLevelDescr
}
